import React from 'react';
import {
  isNodeEmpty,
  PresentationNode
} from '../../../../../api/models/Case/PresentationModel';
import { FachdatenV2Node } from './FachdatenV2Node';
import { Divider, Section, Stack } from '@efast_public/fjd-component-library';

interface FachdatenV2Props {
  readonly data: Record<string, PresentationNode>;
  readonly hideEmpty?: boolean;
  readonly showApplicantLabels: boolean;
}

export function FachdatenV2({
  data,
  hideEmpty,
  showApplicantLabels
}: FachdatenV2Props) {
  let entries = Object.entries(data);
  if (hideEmpty) {
    entries = entries.filter(([, node]) => !isNodeEmpty(node));
  }

  return (
    <>
      <Stack orientation="column" spacing="l">
        {entries.map(([key, node], index) => (
          <>
            <FachdatenV2Node
              key={key}
              node={node}
              depthLevel={1}
              showInSection={true}
              hideEmpty={hideEmpty}
              showApplicantLabel={showApplicantLabels}
            />
            {index < entries.length - 1 && <Divider horizontalSpacing="none" />}
          </>
        ))}
      </Stack>
    </>
  );
}

export default FachdatenV2;
